import { Platform, View } from 'react-native';
import React from 'react';
import Stack from '../../../../../../v2BaseComponents/Stack';
import { colors } from '../../../../../../../utils/theme';
import { getSpacing } from '../../../../../../../utils/spacing';
import ModelMessageTail from './ModelMessageTail';
import UserMessageTail from './UserMessageTail';

type ChatEntryProps = {
    role: 'model' | 'user';
    children: React.ReactNode;
    maxWidth?: number | string;
};

const ChatEntry: React.FC<ChatEntryProps> = ({ role, children, maxWidth }) => {
    return (
        <Stack
            horizontal
            style={{
                alignItems: 'flex-end',
                display: 'flex',
                maxWidth: (maxWidth as any) || '80%',
            }}
        >
            {role === 'model' ? (
                <ModelMessageTail
                    style={{
                        marginRight: -1,
                    }}
                />
            ) : null}
            <View
                style={{
                    paddingVertical: getSpacing(6),
                    paddingHorizontal: getSpacing(8),
                    backgroundColor: role === 'model' ? colors['Chat-Model-Message'] : colors['Chat-User-Message'],
                    borderRadius: 5,
                    maxWidth: '100%',
                    flex: Platform.OS === 'web' ? 1 : undefined,
                }}
            >
                {children}
            </View>
            {role === 'user' ? (
                <UserMessageTail
                    style={{
                        marginLeft: -1,
                    }}
                />
            ) : null}
        </Stack>
    );
};

export default React.memo(ChatEntry);
